import React, { Component } from "react";
import { Link, Route, Redirect } from "react-router-dom";
import intl from "react-intl-universal";
import ScrollableAnchor, { goToAnchor } from "react-scrollable-anchor";
import settings_TE4W from "../img/settings_TE4W.png";
import SGSLogin from "../img/HowTos/SGSLogin.png";
import TEDLogin from "../img/HowTos/TEDLogin.png";
import TEW_Login from "../img/HowTos/TEW_Login.png";
import Esri_Add_Data from "../img/HowTos/Esri_Add_Data.png";
import Esri_Online_Add_Layer from "../img/HowTos/Esri_Online_Add_Layer.png";
import Esri_Portal_Manager from "../img/HowTos/Esri_Portal_Manager.png";
import QGIS_Add_Layer from "../img/HowTos/QGIS_Add_Layer.png";
import OpenLicenseManager from "../img/HowTos/OpenLicenseManager.gif";
import LicenseManagerImg from "../img/HowTos/LicenseManager.gif";
import OpenTEDProjct from "../img/HowTos/OpenTEDProject.gif";
import OpenTEMProject from "../img/HowTos/OpenTEMProject.gif";
import TED_Menu from "../img/HowTos/TED_Menu.png";
import signIn from "../signIn";
import * as SLCommon from "../slCommon";
import pako from "pako";

class FAQ extends Component {
  constructor(props) {
    super(props);
    const hashString = window.location.hash;

    let queryParameters = "";
    if (window.location.search.match(/[?&]displayLogin[=]1/gi) !== null) {
      queryParameters = window.location.search
        .replace(/[?&]displaylogin=1[&]?/i, "")
        .replace(/[&]*$/, "")
        .replace(/^[?]/, "");
      if (queryParameters !== "") queryParameters = "?" + queryParameters;
      return (window.location =
        "/store/signIn?redirect=/gettingStarted" +
        escape(queryParameters) +
        hashString);
    }

    this.state = {
      siteName: "",
      SGSpremiumData: "premium",
      SGSpremiumDataProjectID: "SampleProject",
      BaseGlobeProjectID: "BaseGlobeWeb",
      AtlasILProjectID: "AtlasILWeb",
      accessToken: "[Access_Token]",
      SGBaseUrl: "https://cloud.skylineglobe.com/SG",
      copyText: 'Copy',
      copiedText: 'Copied',   
      packageId: 0,
      cloudProjectId: 0,     
      cloudProject: { },
      cloudKmlLayerDesc: "[Web_Project_ID]",
      cloudFlyLayerDesc: "[Desktop_Project_ID]",
      origHashToScroll: window.location.hash.replace(/^[#](\w+)/i, '$1'),
      terraExplorerDownloadPath: undefined
    };
  }

  componentDidMount() {

    // getting data name (SGSpremiumData)
    var match = window.location.search.match(/[?&]projectName=([^&]+)/i);
    if (match == null)
      match = window.location.search.match(/[?&]premiumData=([^&]+)/i);
    var sgsPremiumData = match != null ? match[1] : this.state.SGSpremiumData;

    match = window.location.search.match(/[?&]packageid=(\d+)/i);
    var packageId = match != null ? parseInt(match[1]) : 0;

    match = window.location.search.match(/[?&]projectId=(\d+)/i);
    var projectId = match != null ? parseInt(match[1]) : 0;
    
    this.setState({
      SGSpremiumData: sgsPremiumData,
      packageId: packageId,
      cloudProjectId: projectId
    });

    if (this.props.props.isLoggedIn){
      this.getUserStatusData(packageId, projectId);
    }
  }

  getUserStatusData(packageId, projectId) {
    fetch(process.env.REACT_APP_API_URL + "GetUserDataByPackage", {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        packageId: packageId,
        projectId: projectId,
      }),
    })
      .then((res) => res.json())
      .then((result) => {
        if (result.Result.toString().toLowerCase() === "success") {
          if (result.Site && result.Site.SiteName) {
            this.setState({
              siteName: result.Site.SiteName
            });
          }

          if (result.Site && result.Site.ViewerAccessToken) {
            this.setState({
              accessToken: result.Site.ViewerAccessToken
            });
          }

          if (result.SGBaseUrl) {
            this.setState({
              SGBaseUrl: result.SGBaseUrl
            });
          }

          if (result.SGSpremiumDataProjectID && result.SGSpremiumDataProjectID != "" && result.Site && result.Site.SiteName) {
            this.setState({
              SGSpremiumDataProjectID: result.SGSpremiumDataProjectID == "AtlasIL" ? this.state.AtlasILProjectID : this.state.BaseGlobeProjectID
            });
          }

          if (result.InstallationPaths !== undefined && result.InstallationPaths.TerraExplorerPro !== undefined) {
            this.setState({ terraExplorerDownloadPath: result.InstallationPaths.TerraExplorerPro});
          }

          if (result.ProjectRun) {
            this.setState({
              cloudProject: result.ProjectRun,
              cloudKmlLayerDesc: result.ProjectRun.CloudKmlLayerDesc,
              cloudFlyLayerDesc: result.ProjectRun.CloudFlyLayerDesc
            });
          }       
          
          // in case of 'EsriSection' a re-scrolling is needed
          if (this.state.origHashToScroll == 'EsriSection') {
            setTimeout(() => {
              goToAnchor(this.state.origHashToScroll, false);
            }, 1000);
          } 
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }

  render() {
const tilesetCode=`(async () => {
  const url = "${this.state.SGBaseUrl}/${
          this.state.siteName ? this.state.siteName : "[CUSTOMER_KEY]"
        }/${
          this.state.accessToken && this.state.accessToken !== "[Access_Token]"
            ? this.state.accessToken
            : "[TOKEN]"
        }/b3dm/${
          this.state.cloudProject && this.state.cloudProject.Cloud3dLayerDesc
            ? this.state.cloudProject.Cloud3dLayerDesc
            : "[MESH_LAYER_ID]"
        }/tileset.json";
  const tileset = await Cesium.Cesium3DTileset.fromUrl(url);
  viewer.scene.primitives.add(tileset);
  viewer.flyTo(tileset);
})();`;

const imageryCode=`(async () => {
  const url = "${this.state.SGBaseUrl}/${
    this.state.siteName ? this.state.siteName : "[CUSTOMER_KEY]"
  }/${
    this.state.accessToken && this.state.accessToken !== "[Access_Token]"
      ? this.state.accessToken
      : "[TOKEN]"
  }/streamer.ashx";
  const provider = new Cesium.WebMapServiceImageryProvider({
    url,
    layers: "${
      this.state.cloudProject && this.state.cloudProject.Cloud2dLayerDesc
        ? this.state.cloudProject.Cloud2dLayerDesc
        : "[IMAGERY_LAYER_ID]"
    }",
    parameters: {
      service: "WMS",
      version: "1.3.0",
      request: "GetMap",
      styles: "",
      format: "image/png",
      transparent: true
    }
  });      
  await provider.readyPromise;
  viewer.imageryLayers.addImageryProvider(provider);
})();`;

    function bytesToBase64(bytes) {
      // Uint8Array -> binary string -> btoa
      let bin = "";
      for (let i = 0; i < bytes.length; i++) bin += String.fromCharCode(bytes[i]);
      return btoa(bin); // Base64 CLASSIC
    }

    const dedent = (str) => {
      const lines = str.replace(/\t/g, "  ").split("\n");
    
      // הסר שורות ריקות בהתחלה ובסוף
      while (lines.length && lines[0].trim() === "") lines.shift();
      while (lines.length && lines[lines.length - 1].trim() === "") lines.pop();
    
      // מצא הזחה מינימלית
      const indents = lines
        .filter(l => l.trim() !== "")
        .map(l => l.match(/^ */)[0].length);
    
      const minIndent = Math.min(...indents);
    
      return lines.map(l => l.slice(minIndent)).join("\n");
    };
    

    const buildSandcastleFromCodeOnly = (codeOnly) => {
      const js =
    `const viewer = new Cesium.Viewer("cesiumContainer");
    
    ${dedent(codeOnly)}`;
    
      const html = `<div id="cesiumContainer" class="fullSize"></div>`;
    
      return buildSandcastleShareUrl(js, html);
    }; 
    
    function buildSandcastleShareUrl(jsCode, htmlCode = "") {
      const json = JSON.stringify([jsCode, htmlCode]);
      const inner = json.slice(2, -2);
      const compressed = pako.deflateRaw(inner);
      const b64 = bytesToBase64(compressed);
      return `https://sandcastle.cesium.com/#c=${b64}`;
    }

    const tilesetCesiumUrl = buildSandcastleFromCodeOnly(tilesetCode);
    const imageryCesiumUrl = buildSandcastleFromCodeOnly(imageryCode);
    return (
      <main className="container-fluid col-md-9 faqMain">
        <div>
          <div>
            <span style={{ fontSize: "28px" }}>
              {this.state.cloudProjectId <= 0 ? ("Getting Started: Streaming " + this.state.SGSpremiumData + " Data") : "View Project Result"}
            </span>
            <br />
            <br />
            <span>
              {this.state.cloudProjectId <= 0 ? <React.Fragment>
              Listed below are frequently asked questions about SkylineCloud data streaming options. If you have any additional questions, contact us at
              <a href="mailto:support@skylinesoft.com">
                support@skylinesoft.com
              </a>
              .</React.Fragment> : "Access your project output with any of the following viewers:"} 
            </span>
            <br />
            <br />
            <ul className="faqContentBullets">
              <li>
                <a href="#TEFSection">
                  {this.state.cloudProjectId <= 0 ? 
                  <React.Fragment>How to access {this.state.SGSpremiumData} data with TerraExplorer Fusion</React.Fragment>
                  : "TerraExplorer Fusion"}
                </a>
              </li>
              <li>
                <a href="#TerraExplorer_ProSection">
                {this.state.cloudProjectId <= 0 ? 
                  <React.Fragment>How to access {this.state.SGSpremiumData} data with
                  TerraExplorer for Desktop</React.Fragment>
                  : "TerraExplorer for Desktop"}
                </a>
              </li>
              <li>
                <a href="#CesiumSection">
                {this.state.cloudProjectId <= 0 ? 
                  <React.Fragment>How to access {this.state.SGSpremiumData} data with a Cesium viewer</React.Fragment>
                  : "Cesium viewer"}
                </a>
              </li>
              {
                this.state.SGSpremiumDataProjectID == this.state.AtlasILProjectID
                  ?
                  <div>
                    <li>
                      <a href="#QGISWMSSection">
                        {this.state.cloudProjectId <= 0 ?
                          <React.Fragment>How to access {this.state.SGSpremiumData} 2D data with QGIS</React.Fragment>
                          : "QGIS (2D Data)"}
                      </a>
                    </li>
                    <li>
                      {this.state.cloudProjectId <= 0 ?
                        <a href="#EsriSection">
                          How to access {this.state.SGSpremiumData} 3D data with Esri
                          viewers
                        </a> :
                        <a href={"https://support.skylinesoft.com/hc/en-us/requests/new?tf_subject=PM%20cloud%20processing&tf_anonymous_requester_email=" + this.props.props.userName + "&tf_360015036959=pm_cloud_processing&tf_description=Enter%20description%20here:%20projectId" + this.state.cloudProjectId} target="_blank">
                          Esri viewers - contact support
                        </a>
                      }
                    </li>
                    <li>
                      {this.state.cloudProjectId <= 0 ?
                        <a href="#EsriWMSSection">
                          How to access {this.state.SGSpremiumData} 2D data with Esri
                          viewers
                        </a> :
                        <a href={"https://support.skylinesoft.com/hc/en-us/requests/new?tf_subject=PM%20cloud%20processing&tf_anonymous_requester_email=" + this.props.props.userName + "&tf_360015036959=pm_cloud_processing&tf_description=Enter%20description%20here:%20projectId" + this.state.cloudProjectId} target="_blank">
                          Esri viewers - contact support
                        </a>
                      }
                    </li>
                  </div>
                  :
                  ""
              }
            </ul>
          </div>
          <ScrollableAnchor id={"TEFSection"}>
            <div className="FAQ_Pricing gettingStartedSection">
              <h5 className="headersHowTo">
              {this.state.cloudProjectId <= 0 ? 
                  <React.Fragment>How to access {this.state.SGSpremiumData} data with TerraExplorer Fusion</React.Fragment>
                  : "TerraExplorer Fusion"}
              </h5>
              <span>
                TerraExplorer Fusion is a lightweight, multi-platform 3D GIS
                web viewer. TerraExplorer Fusion provides powerful analysis
                tools that promote an enhanced understanding of the 3D
                environment including distance and slope, area, volume,
                contour/slope map, viewshed. More about:{" "}
                <a href="https://www.skylinesoft.com/terraexplorer-fusion/">
                  TerraExplorer Fusion
                </a>                
              </span>
              <br />
              <br />
              <div>
                <b>
                  Click here to open TerraExplorer Fusion with the{" "}
                  {this.state.SGSpremiumData} project:{" "}
                </b>
              </div>
              <a
                href={
                  this.state.SGBaseUrl + "/TEF/TE.html?project=" + 
                  (this.state && this.state.siteName !== ""
                    ? this.state.SGBaseUrl + "/" +
                    this.state.siteName +
                    "/projects/" +
                    (this.state.cloudProjectId > 0 ? this.state.cloudFlyLayerDesc : (this.state.SGSpremiumData + "Desktop")) +
                    "?token=" +
                    this.state.accessToken
                    : this.state.SGBaseUrl + "/[CUSTOMER_KEY]/projects/" +
                    (this.state.cloudProjectId > 0 ? this.state.cloudFlyLayerDesc : (this.state.SGSpremiumData + "Desktop")) +
                    "?token=" +
                    this.state.accessToken)       
                }
                target="_blamk"
              >
                
                {this.state.SGBaseUrl + "/TEF/TE.html?project="}
                  {this.state && this.state.siteName !== ""
                    ? this.state.SGBaseUrl + "/" +
                    this.state.siteName +
                    "/projects/" +
                    (this.state.cloudProjectId > 0 ? this.state.cloudFlyLayerDesc : (this.state.SGSpremiumData + "Desktop")) +
                    "?token=" +
                    this.state.accessToken
                    : this.state.SGBaseUrl + "/[CUSTOMER_KEY]/projects/" +
                    (this.state.cloudProjectId > 0 ? this.state.cloudFlyLayerDesc : (this.state.SGSpremiumData + "Desktop")) +
                    "?token=" +
                    this.state.accessToken}
                  
              </a>
              <a
                href={
                  this.state.SGBaseUrl + "/TEF/TE.html?project=" +
                    (this.state && this.state.siteName !== ""
                    ? this.state.SGBaseUrl + "/" +
                    this.state.siteName +
                    "/projects/" +
                    (this.state.cloudProjectId > 0 ? this.state.cloudFlyLayerDesc : (this.state.SGSpremiumData + "Desktop")) +
                    "?token=" +
                    this.state.accessToken
                    : this.state.SGBaseUrl + "/[CUSTOMER_KEY]/projects/" +
                    (this.state.cloudProjectId > 0 ? this.state.cloudFlyLayerDesc : (this.state.SGSpremiumData + "Desktop")) +
                    "?token=" +
                    this.state.accessToken)
                }
                target="_blamk"
                style={{color: '#ffffff', backgroundColor: '#0286bb'}}
                className="btn btn-primary text-capitalize ml-3"
              >
                View
              </a>
            </div>
          </ScrollableAnchor>
          <ScrollableAnchor id={"TerraExplorer_ProSection"}>
            <div className="FAQ_Pricing gettingStartedSection">
              <h5 className="headersHowTo">
                {this.state.cloudProjectId <= 0 ?
                  <React.Fragment>How to access {this.state.SGSpremiumData} data with
                    TerraExplorer for Desktop</React.Fragment>
                  : "TerraExplorer for Desktop"}
              </h5>
              <span>
                TerraExplorer for Desktop is a cutting-edge 3D GIS desktop
                viewer and creator that provides powerful tools and a
                high-resolution 3D environment in which to view, query, analyze
                and present geospatial data. More about:{" "}
                <a href="https://www.skylinesoft.com/terraexplorer-desktop">
                  TerraExplorer for Desktop
                </a>
              </span>
              <br />
              <br />
              <div>
                <b>Download and install TerraExplorer for Desktop: </b>
              </div>
              <ul className="FAQ_ul">
                <li>
                  Click here to download{"  "}
                  <a href={this.state.terraExplorerDownloadPath ? this.state.terraExplorerDownloadPath : "https://cloud.skylineglobe.com/SGCloud/Downloads/TEPro.zip"}>
                    TerraExplorer for Desktop
                  </a>
                  .
                </li>
                <li>Extract the files.</li>
                <li>
                  Double-click the <b>setup.exe</b> file and follow the
                  Installation Wizard to install the application.
                </li>
              </ul>
              <br />
              <div>
                <b>Open the {this.state.SGSpremiumData} project:</b>
              </div>
              <ul className="FAQ_ul">
                <li>
                  Start TerraExplorer for Desktop application from the Windows
                  Start menu or from the desktop shortcut.
                </li>
                <li>
                  From the <b>File</b> menu <img src={TED_Menu} />, point to{" "}
                  <b>Open</b> and select <b>Open Project from File.</b>
                </li>
                <li>
                  In the <b>Open</b> field, Copy-paste the following URL, and
                  click <b>OK</b>:
                  <br />
                  <b className="copyTextForTED">
                    {this.state && this.state.siteName !== ""
                      ? this.state.SGBaseUrl + "/" +
                        this.state.siteName +
                        "/projects/" +
                        (this.state.cloudProjectId > 0 ? this.state.cloudFlyLayerDesc : (this.state.SGSpremiumData + "Desktop")) +
                        "?token=" +
                        this.state.accessToken
                      : this.state.SGBaseUrl + "/[CUSTOMER_KEY]/projects/" +
                        (this.state.cloudProjectId > 0 ? this.state.cloudFlyLayerDesc : (this.state.SGSpremiumData + "Desktop")) +
                        "?token=" +
                        this.state.accessToken}
                  </b>
                  <button className="btn btn-outline-primary text-capitalize ml-1 copyToClipboard" onClick={(event) => {
                    var currentTarget = event.currentTarget;
                    SLCommon.copyToClipboard(document.getElementsByClassName("copyTextForTED")[0])
                      .then(() => { currentTarget.innerText = this.state.copiedText });
                  }}>{this.state.copyText}</button>
                </li>
              </ul>

              <span>
                <b>** Note:</b> For additional functionality, you can upgrade
                your TerraExplorer for Desktop - Viewer to TerraExplorer for
                Desktop - Plus. Click{" "}
                <a target="_blank" href="https://support.skylinesoft.com/hc/en-us/articles/4402316782226-TerraExplorer-Family-Comparison-Table">
                  here
                </a>{" "}
                for a comparison between Viewer and Plus. To upgrade, contact us
                at{" "}
                <a href="mailto:support@skylinesoft.com">support@skylinesoft.com</a>
                .
              </span>
              <div className={"text-center mt-4 mb-4"} style={ this.state.cloudProjectId > 0 ? {display: 'none'} : { } }>
                <img
                  src={OpenTEDProjct}
                  className="text-center howTosImg img-responsive imgStaticHeight"
                />
              </div>
            </div>
          </ScrollableAnchor>
          <ScrollableAnchor id={"CesiumSection"}>
  <div className="FAQ_Pricing gettingStartedSection">
    <h5 className="headersHowTo" style={{ color: "" }}>
      {this.state.cloudProjectId <= 0 ? (
        <React.Fragment>
          How to access {this.state.SGSpremiumData} data with a Cesium viewer
        </React.Fragment>
      ) : (
        "Cesium viewer"
      )}
    </h5>

    <div>
      <p>
      You can access {this.state.SGSpremiumData} data in your Cesium viewer.
      Note: If the data is configured as public, you can access the layers directly — no token and no login are required.
      </p>

      <p>
        To access private layers, you can either include a <b>token</b> in each
        data URL, or alternatively authenticate by performing a login using a{" "}
        <b>username and password</b>.
      </p>

      <ul className="FAQ_ul">
      {this.state.cloudProjectId > 0 ? (
        <React.Fragment>
          <li>
            To load a 3D Tileset layer:
            <a
              href={tilesetCesiumUrl}
              target="_blamk"
              style={{ color: "#ffffff", backgroundColor: "#0286bb" }}
              className="btn btn-primary text-capitalize ml-3"
            >
              View in cesium
            </a>
            <pre className="codeScript">{tilesetCode}</pre>
          </li>

          <li>
            To load an imagery layer:
            <a
              href={imageryCesiumUrl}
              target="_blamk"
              style={{ color: "#ffffff", backgroundColor: "#0286bb" }}
              className="btn btn-primary text-capitalize ml-3"
            >
              View in cesium
            </a>
            <pre className="codeScript">{imageryCode}</pre>
          </li>
        </React.Fragment>
      ) : (
        <React.Fragment>
        <li>
          To log in using credentials: <br />
          <pre className="codeScript">{`(async () => {
    const response = await fetch(
        "${this.state.SGBaseUrl}/${
            this.state.siteName ? this.state.siteName : "[CUSTOMER_KEY]"
        }/ConnectSG",
        {
            method: "POST",
            credentials: "include",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                request: "login",
                username: "[USERNAME]",
                password: "[PASSWORD]"
            })
        }
    );
    if (!response.ok) {
        console.error("Login failed.");
        return;
    }
    const responseJson = await response.json();
    if (responseJson.result !== "success") {
        console.error(
            "Login failed: " + responseJson.resultMessageDescription
        );
    } else {
        console.log("Login succeeded.");
    }
})();`}</pre>
        </li>

        <li>
          To load a 3D Tileset layer:
          <a
            href={tilesetCesiumUrl}
            target="_blamk"
            style={{color: '#ffffff', backgroundColor: '#0286bb'}}
            className="btn btn-primary text-capitalize ml-3"
          >
            View in cesium
          </a>
          <pre className="codeScript">{tilesetCode}</pre>
        </li>
        <li>
          To load a Point Cloud layer: <br />
          <pre className="codeScript">{`(async () => {
    const url = "${this.state.SGBaseUrl}/${
      this.state.siteName ? this.state.siteName : "[CUSTOMER_KEY]"
    }/${
      this.state.accessToken && this.state.accessToken !== "[Access_Token]"
        ? this.state.accessToken
        : "[TOKEN]"
    }/pnts/[POINT_CLOUD_LAYER_ID]/tileset.json";
    const tileset = await Cesium.Cesium3DTileset.fromUrl(url);
    viewer.scene.primitives.add(tileset);
    viewer.flyTo(tileset);
})();`}</pre>
        </li>

        <li>
          To load an imagery layer:
          <a
            href={imageryCesiumUrl}
            target="_blamk"
            style={{color: '#ffffff', backgroundColor: '#0286bb'}}
            className="btn btn-primary text-capitalize ml-3"
          >
            View in cesium
          </a>
          <pre className="codeScript">{imageryCode}</pre>
        </li>

        <li>
          <p>To load an elevation layer as a terrain provider: </p>
          <pre className="codeScript">{`From the SGS installation folder, copy the following directory into your Cesium application folder:
        Resources\\CesiumJS\\SGSTerrainProvider
In the main HTML file of your Cesium application, add the following script reference:
        <script src="SGSTerrainProvider/SGSTerrainProvider.js" type="text/javascript"></script>
Then, configure the terrain provider in your Cesium viewer:
        viewer.terrainProvider = new SGSTerrainProvider({
            viewer: viewer,
            requestVertexNormals: false,
            url: '${this.state.SGBaseUrl}/${
              this.state.siteName ? this.state.siteName : "[CUSTOMER_KEY]"
            }/Elevation',
            layers: '[ELEVATION_LAYER_ID].mpt' // or .tbp
        });`}</pre>
        </li>
        </React.Fragment>)}
      </ul>
    </div>
  </div>
</ScrollableAnchor>

          {
            this.state.SGSpremiumDataProjectID == this.state.AtlasILProjectID
              ?
              <div>
                <ScrollableAnchor id={"QGISWMSSection"}>
                  <div className="FAQ_Pricing gettingStartedSection">
                    <h5 className="headersHowTo">
                      {this.state.cloudProjectId <= 0 ?
                        <React.Fragment>How to access {this.state.SGSpremiumData} 2D data with QGIS</React.Fragment>
                        : "QGIS (2D Data)"}
                    </h5>
                    <div>
                      <p>
                        You can access {this.state.SGSpremiumData} WMS/WMTS
                        layers in your QGIS viewer.
                      </p>
                      <div>
                        <b>Create a new WMS/WMTS connection</b>
                      </div>
                      <ul className="FAQ_ul">
                        <li>
                          From the <b>Layer</b> menu, select{" "}
                          <b>Data Source Manager</b>.
                        </li>
                        <li>
                          In the <b>Navigation</b> pane, select <b>WMS/WMTS</b>.
                        </li>
                        <li>
                          In the <b>Layers</b> tab, click <b>New</b>.
                        </li>
                        <li>
                          In the <b>Create a New WMS/WMTS Connection</b> dialog box, enter the
                          following:
                          <ul>
                            <li>
                              <b>Name</b> - Enter a name for the connection.
                            </li>
                            <li>
                              <b>WMS URL</b> -{" "}
                              <b className="copyTextForEsriPortalURLQGISWMS">
                                {this.state && this.state.siteName !== ""
                                  ? this.state.SGBaseUrl + "/" +
                                  this.state.siteName +
                                  "/streamer.ashx?token=" +
                                  this.state.accessToken
                                  : this.state.SGBaseUrl + "/[CUSTOMER_KEY]/streamer.ashx?token=[Access_Token]"}
                              </b>
                              <button className="btn btn-outline-primary text-capitalize ml-1 copyToClipboard" onClick={(event) => {
                                var currentTarget = event.currentTarget;
                                SLCommon.copyToClipboard(document.getElementsByClassName("copyTextForEsriPortalURLQGISWMS")[0])
                                  .then(() => { currentTarget.innerText = this.state.copiedText });
                              }}>{this.state.copyText}</button>
                            </li>
                            <li>
                              <b>WMTS URL</b> -{" "}
                              <b className="copyTextForEsriPortalURLQGISWMTS">
                                {this.state && this.state.siteName !== ""
                                  ? this.state.SGBaseUrl + "/" +
                                  this.state.siteName +
                                  "/streamer.ashx?token=" +
                                  this.state.accessToken +
                                  "&request=GetCapabilities&Version=1.0.0&Service=WMTS"
                                  : this.state.SGBaseUrl + "/[CUSTOMER_KEY]/streamer.ashx?token=[Access_Token]&request=GetCapabilities&Version=1.0.0&Service=WMTS"}
                              </b>
                              <button className="btn btn-outline-primary text-capitalize ml-1 copyToClipboard" onClick={(event) => {
                                var currentTarget = event.currentTarget;
                                SLCommon.copyToClipboard(document.getElementsByClassName("copyTextForEsriPortalURLQGISWMTS")[0])
                                  .then(() => { currentTarget.innerText = this.state.copiedText });
                              }}>{this.state.copyText}</button>
                            </li>
                          </ul>
                        </li>
                        <li>
                          Click <b>OK</b>.
                        </li>
                      </ul>
                      <ul className="FAQ_ul">
                        <span style={{ marginLeft: "-40px" }}>
                          <b>Load a layer:</b>
                        </span>
                        <li>
                          In the <b>Data Source Manager</b>, click the <b>Layers</b>{" "}
                          tab, and select the new connection’s name.
                        </li>
                        <li>
                          Click <b>Connect</b>.
                        </li>
                        <li>
                          <b>Select the layer to access</b>.
                        </li>
                        <li>
                          Click <b>Add</b> and <b>Close</b>.
                          <br />
                          <img src={QGIS_Add_Layer} />
                        </li>
                      </ul>
                    </div>
                    <br />
                  </div>
                </ScrollableAnchor>
                {this.state.cloudProjectId <= 0 ? <div>
                  <ScrollableAnchor id={"EsriSection"}>
                    <div className="FAQ_Pricing gettingStartedSection">
                      <h5 className="headersHowTo">
                        How to access {this.state.SGSpremiumData} 3D data with Esri
                        viewers
                      </h5>
                      <div>
                        <p>
                          You can access SkylineCloud 3DML layers exposed as i3S in your
                          Esri viewer in ArcGIS Earth, ArcGIS Pro and ArcGIS Online.
                          <br />
                          <b>Note: </b>The following Esri versions are supported: ArcGIS
                          Pro v2.9.0 and above, ArcGIS Earth v1.14, and ArcGIS Online
                          January 2022 update.
                        </p>
                        <b />
                      </div>
                      <div>
                        <b>In ArcGIS Earth:</b>
                        <br />
                      </div>
                      <ul className="FAQ_ul">
                        <span style={{ marginLeft: "-40px" }}>
                          <b>Connect to SkylineGlobe Server</b>
                        </span>
                        <li>
                          Open the <b>Portal Manager</b>:
                          <br />
                          <img src={Esri_Portal_Manager} />
                        </li>
                        <li>
                          {" "}
                          Click <b>Add Portal</b>. The <b>Add Portal</b> dialog box is
                          displayed.
                          <br />
                        </li>
                        <li>
                          In the <b>URL </b>copy-paste the following URL, and click{" "}
                          <b>OK</b>:<br /> {" "}
                          <b className="copyTextForEsriPortalURL">
                            {this.state && this.state.siteName !== ""
                              ? this.state.SGBaseUrl + "/" +
                              this.state.siteName +
                              "/" +
                              this.state.accessToken +
                              "/arcgis"
                              : this.state.SGBaseUrl + "/[CUSTOMER_KEY]/[TOKEN]/arcgis"}
                          </b>
                          <button className="btn btn-outline-primary text-capitalize ml-1 copyToClipboard" onClick={(event) => {
                            var currentTarget = event.currentTarget;
                            SLCommon.copyToClipboard(document.getElementsByClassName("copyTextForEsriPortalURL")[0])
                              .then(() => { currentTarget.innerText = this.state.copiedText });
                          }}>{this.state.copyText}</button>
                        </li>
                        <li>
                          In the <b>Portal Manager</b>, right-click the{" "}
                          <b>SkylineCloud</b> connection, and select{" "}
                          <b>Set as Active Portal</b>.
                        </li>
                      </ul>
                      <ul className="FAQ_ul">
                        <span style={{ marginLeft: "-40px" }}>
                          <b>Load a layer</b>
                        </span>
                        <li>
                          {" "}
                          Click <b>Add Data {"   "}</b>
                          {"   "} <img src={Esri_Add_Data} />.
                        </li>
                        <li>
                          Do either of the following:
                          <ul>
                            <li>
                              In the <b>Add Data </b>dialog box, click <b>Portal</b>,
                              and then in the <b>My Content</b> list, select the layer
                              you want.
                            </li>
                            <li>
                              In the <b>Add Data </b>dialog box, click{" "}
                              <b>Enter a URL</b>, and then in the <b>URL</b> field
                              copy-paste the following URL, and click <b>OK</b>:{" "}
                              <b className="copyTextForArcGisEarthLayer">
                                {this.state && this.state.siteName !== ""
                                  ? this.state.SGBaseUrl + "/" +
                                  this.state.siteName +
                                  "/" +
                                  this.state.accessToken +
                                  "/arcgis/rest/services/" +
                                  (this.state.cloudProjectId > 0 && this.state.cloudProject.Cloud3dLayerDesc ? this.state.cloudProject.Cloud3dLayerDesc : "[LayerName].[LayerID]") +
                                  "/SceneServer"
                                  : this.state.SGBaseUrl + "/[CUSTOMER_KEY]/[TOKEN]/arcgis/rest/services/" +
                                  (this.state.cloudProjectId > 0 && this.state.cloudProject.Cloud3dLayerDesc ? this.state.cloudProject.Cloud3dLayerDesc : "[LayerName].[LayerID]") +
                                  "/SceneServer"}
                              </b>
                              <button className="btn btn-outline-primary text-capitalize ml-1 copyToClipboard" onClick={(event) => {
                                var currentTarget = event.currentTarget;
                                SLCommon.copyToClipboard(document.getElementsByClassName("copyTextForArcGisEarthLayer")[0])
                                  .then(() => { currentTarget.innerText = this.state.copiedText });
                              }}>{this.state.copyText}</button>
                            </li>
                          </ul>
                        </li>
                        <li>
                          Click <b>Add</b>.
                        </li>
                      </ul>
                      <div>
                        <b>In ArcGIS Pro:</b>
                        <br />
                      </div>
                      <ul className="FAQ_ul">
                        <span style={{ marginLeft: "-40px" }}>
                          <b>Create a project</b>
                        </span>
                        <li>Create a new project using a Blank template.</li>
                        <li>
                          On the <b>Blank Templates</b>, from the <b>New tab</b>, select{" "}
                          <b>Global Scene.</b>
                        </li>
                        <li>
                          Enter a Project name and the project location and click{" "}
                          <b>OK</b>.
                        </li>
                      </ul>
                      <ul className="FAQ_ul">
                        <span style={{ marginLeft: "-40px" }}>
                          <b>Connect to SkylineGlobe Server</b>
                        </span>
                        <li>
                          Click the <b>Project</b> tab.
                        </li>
                        <li>
                          In the <b>Portals</b> page, click <b>Add Portal</b>.
                        </li>
                        <li>
                          In the URL field enter the following, and click <b>OK</b>:
                          <br />
                          <b className="copyTextForArcGISProURL">
                            {this.state && this.state.siteName !== ""
                              ? this.state.SGBaseUrl + "/" +
                              this.state.siteName +
                              "/" +
                              this.state.accessToken +
                              "/arcgis"
                              : this.state.SGBaseUrl + "/[CUSTOMER_KEY]/[TOKEN]/arcgis"}
                          </b>
                          <button className="btn btn-outline-primary text-capitalize ml-1 copyToClipboard" onClick={(event) => {
                            var currentTarget = event.currentTarget;
                            SLCommon.copyToClipboard(document.getElementsByClassName("copyTextForArcGISProURL")[0])
                              .then(() => { currentTarget.innerText = this.state.copiedText });
                          }}>{this.state.copyText}</button>
                        </li>
                        <li>
                          In the <b>Portal Manager</b>, right-click the{" "}
                          <b>SkylineCloud</b> connection, and select{" "}
                          <b>Set as Active Portal.</b>
                        </li>
                        <li>Click the back arrow to return to the scene.</li>
                        <br />
                        <span style={{ marginLeft: "-40px" }}>
                          <b>Load a layer</b>
                        </span>
                        <li>
                          Do either of the following to load the{" "}
                          {this.state.SGSpremiumData} data:
                          <ul>
                            <li>
                              In the <b>Catalog</b> pane, on the <b>Portal</b> tab, in
                              the <b>My Content section</b>, right-click the layer you
                              want, and select <b>Add to Current Map</b>.
                            </li>
                            <li>
                              On the <b>Map</b> tab, from the <b>Add Data</b> drop-down
                              menu, select <b>Data from Path</b>. Then in the{" "}
                              <b>Add Data From Path</b> dialog that opens, copy-paste
                              the following URL, and click <b>Add</b>:{" "}
                              <b className="copyTextForArcGISProLayerURL">
                                {this.state && this.state.siteName !== ""
                                  ? this.state.SGBaseUrl + "/" + this.state.siteName + "/" +
                                  this.state.accessToken +
                                  "/arcgis/rest/services/" +
                                  (this.state.cloudProjectId > 0 && this.state.cloudProject.Cloud3dLayerDesc ? this.state.cloudProject.Cloud3dLayerDesc : "[LayerName].[LayerID]") +
                                  "/SceneServer"
                                  : this.state.SGBaseUrl + "/[CUSTOMER_KEY]/[TOKEN]/arcgis/rest/services/" +
                                  (this.state.cloudProjectId > 0 && this.state.cloudProject.Cloud3dLayerDesc ? this.state.cloudProject.Cloud3dLayerDesc : "[LayerName].[LayerID]") +
                                  "/SceneServer"}
                              </b>
                              <button className="btn btn-outline-primary text-capitalize ml-1 copyToClipboard" onClick={(event) => {
                                var currentTarget = event.currentTarget;
                                SLCommon.copyToClipboard(document.getElementsByClassName("copyTextForArcGISProLayerURL")[0])
                                  .then(() => { currentTarget.innerText = this.state.copiedText });
                              }}>{this.state.copyText}</button>
                            </li>
                          </ul>
                        </li>
                      </ul>
                      <div>
                        <b>In ArcGIS Online:</b>
                        <br />
                      </div>
                      <ul className="FAQ_ul">
                        <li>
                          Open{" "}
                          <a
                            href="https://www.arcgis.com/home/webscene/viewer.html"
                            target="_blank"
                          >
                            https://www.arcgis.com/home/webscene/viewer.html
                          </a>
                        </li>
                        <li>Sign in with an ArcGIS account.</li>
                      </ul>
                      <ul className="FAQ_ul">
                        <span style={{ marginLeft: "-40px" }}>
                          <b>Load a layer</b>
                        </span>
                        <li>
                          Open the <b>Designer</b> by clicking on <b>Modify scene</b>.
                          Then, click <b>Add Layers</b>, and then click{" "}
                          <b>Enter layer URL</b>.
                          <br />
                          <img src={Esri_Online_Add_Layer} />
                        </li>
                        <li>
                          In the URL field copy-paste the URL below, and click <b>OK</b>.
                          <br />{" "}
                          <b className="copyTextForArcGISOnlineURL">
                            {this.state && this.state.siteName !== ""
                              ? this.state.SGBaseUrl + "/" + this.state.siteName + "/" +
                              this.state.accessToken +
                              "/arcgis/rest/services/" +
                              (this.state.cloudProjectId > 0 && this.state.cloudProject.Cloud3dLayerDesc ? this.state.cloudProject.Cloud3dLayerDesc : "[LayerName].[LayerID]") +
                              "/SceneServer"
                              : this.state.SGBaseUrl + "Default/[TOKEN]/arcgis/rest/services/" +
                              (this.state.cloudProjectId > 0 && this.state.cloudProject.Cloud3dLayerDesc ? this.state.cloudProject.Cloud3dLayerDesc : "[LayerName].[LayerID]") +
                              "/SceneServer"}
                          </b>
                          <button className="btn btn-outline-primary text-capitalize ml-1 copyToClipboard" onClick={(event) => {
                            var currentTarget = event.currentTarget;
                            SLCommon.copyToClipboard(document.getElementsByClassName("copyTextForArcGISOnlineURL")[0])
                              .then(() => { currentTarget.innerText = this.state.copiedText });
                          }}>{this.state.copyText}</button>
                          <br />
                          <b>Note:</b> All SGS layers must be on public HTTPS servers.
                        </li>
                        <li>
                          Click <b>Add</b>.
                        </li>
                      </ul>
                    </div>
                  </ScrollableAnchor>
                  <ScrollableAnchor id={"EsriWMSSection"}>
                    <div className="FAQ_Pricing gettingStartedSection">
                      <h5 className="headersHowTo">
                        How to access {this.state.SGSpremiumData} 2D data with Esri
                        viewers
                      </h5>
                      <div>
                        <p>
                          You can access {this.state.SGSpremiumData} 2D raster layers in
                          your Esri viewer in ArcGIS Earth, ArcGIS Pro and ArcGIS
                          Online.
                          <br />
                          <b>Note: </b>The following Esri versions are supported: ArcGIS
                          Pro v2.9.0 and above, ArcGIS Earth v1.14, and ArcGIS Online
                          January 2022 update.
                        </p>
                        <b />
                      </div>
                      <div>
                        <b>In ArcGIS Earth:</b>
                        <br />
                        <p>
                          <b>Load layers</b>
                        </p>
                      </div>
                      <ul className="FAQ_ul">
                        <li>
                          Open the <b>Settings</b> dialog, and under the <b>General</b>{" "}
                          tab, set the <b>Spatial Reference</b> to <b>WGS 84</b>.
                        </li>
                        <li>
                          {" "}
                          Click <b>Add Data {"   "}</b>
                          {"   "} <img src={Esri_Add_Data} />
                        </li>
                        <li>
                          In the Add Data dialog box, click <b>Enter a URL</b>, and then
                          in the Type field, select <b>OGC WMS</b> or <b>OGC WMTS</b>.
                        </li>
                        <li>
                          In the <b>URL</b> field, copy-paste the following URL, select
                          the required layers, and click <b>OK</b>:
                          <br />
                          <b className="copyTextForEsriPortalURL2D">
                            {this.state && this.state.siteName !== ""
                              ? this.state.SGBaseUrl + "/" +
                              this.state.siteName +
                              "/" +
                              this.state.accessToken +
                              "/arcgis/rest/services/wmsserver"
                              : this.state.SGBaseUrl + "/[CUSTOMER_KEY]/[TOKEN]/arcgis/rest/services/wmsserver"}
                          </b>
                          <button className="btn btn-outline-primary text-capitalize ml-1 copyToClipboard" onClick={(event) => {
                            var currentTarget = event.currentTarget;
                            SLCommon.copyToClipboard(document.getElementsByClassName("copyTextForEsriPortalURL2D")[0])
                              .then(() => { currentTarget.innerText = this.state.copiedText });
                          }}>{this.state.copyText}</button>
                        </li>
                        <li>
                          Click <b>Add</b>.
                        </li>
                      </ul>
                      <div>
                        <b>In ArcGIS Pro:</b>
                        <br />
                      </div>
                      <ul className="FAQ_ul">
                        <span style={{ marginLeft: "-40px" }}>
                          <b>Create a project</b>
                        </span>
                        <li>
                          On the <b>Blank Templates </b>, from the <b>New tab</b>,
                          select <b>Global Scene.</b>
                        </li>
                        <li>
                          Enter a Project name and the project location and click{" "}
                          <b>OK</b>.
                        </li>
                      </ul>
                      <ul className="FAQ_ul">
                        <span style={{ marginLeft: "-40px" }}>
                          <b>Load a layer</b>
                        </span>
                        <li>
                          On the <b>Insert</b> tab, click <b>Add Item</b>, and select
                          either <b>New WMS Server</b> or <b>New WMTS Server</b>.
                        </li>
                        <li>
                          In the <b>URL</b> field enter the following, and click{" "}
                          <b>OK</b>:
                          <br />
                          <b>For WMS:</b>
                          <br />
                          <b className="copyTextForEsriPortalURL2DWMS">
                            {this.state && this.state.siteName !== ""
                              ? this.state.SGBaseUrl + "/" +
                              this.state.siteName +
                              "/" +
                              this.state.accessToken +
                              "/arcgis/rest/services/wmsserver"
                              : this.state.SGBaseUrl + "/[CUSTOMER_KEY]/[TOKEN]/arcgis/rest/services/wmsserver"}
                          </b>
                          <button className="btn btn-outline-primary text-capitalize ml-1 copyToClipboard" onClick={(event) => {
                            var currentTarget = event.currentTarget;
                            SLCommon.copyToClipboard(document.getElementsByClassName("copyTextForEsriPortalURL2DWMS")[0])
                              .then(() => { currentTarget.innerText = this.state.copiedText });
                          }}>{this.state.copyText}</button>
                          <br />
                          <b>For WMTS:</b>
                          <br />
                          <b className="copyTextForEsriPortalURL2DWMTS">
                            {this.state && this.state.siteName !== ""
                              ? this.state.SGBaseUrl + "/" +
                              this.state.siteName +
                              "/" +
                              this.state.accessToken +
                              "/arcgis/rest/services/mapserver"
                              : this.state.SGBaseUrl + "/[CUSTOMER_KEY]/[TOKEN]/arcgis/rest/services/mapserver"}
                          </b>
                          <button className="btn btn-outline-primary text-capitalize ml-1 copyToClipboard" onClick={(event) => {
                            var currentTarget = event.currentTarget;
                            SLCommon.copyToClipboard(document.getElementsByClassName("copyTextForEsriPortalURL2DWMTS")[0])
                              .then(() => { currentTarget.innerText = this.state.copiedText });
                          }}>{this.state.copyText}</button>
                        </li>
                        <li>Click OK.</li>
                        <li>
                          In the <b>Catalog</b> pane, on the <b>Favorites</b> tab, open
                          the connection that recently added, right-click the layer you
                          want, and select <b>Add to Current Map</b>.
                        </li>
                      </ul>
                      <div>
                        <b>In ArcGIS Online:</b>
                        <br />
                        <p>
                          <b>Connect to SkylineGlobe Server</b>
                        </p>
                      </div>
                      <ul className="FAQ_ul">
                        <li>
                          Connect to a base map of spatial reference WGS 84{" "}
                          <a
                            href="https://www.arcgis.com/home/group.html?id=4c790318395940c18a16e8acd721de25#overview"
                            target="_blank"
                          >
                            https://www.arcgis.com/home/group.html?id=4c790318395940c18a16e8acd721de25#overview
                          </a>
                        </li>
                        <li>
                          Hover over the thumbnail of the layer you want to add, and
                          click <b>Open in Map Viewer</b>.
                        </li>
                        <li>
                          Click <b>Open in Map Viewer Classic</b>.
                        </li>
                        <li>Log in with an ArcGIS account.</li>
                      </ul>
                      <ul className="FAQ_ul">
                        <span style={{ marginLeft: "-40px" }}>
                          <b>Load a layer</b>
                        </span>
                        <li>
                          Click <b>Add</b>, and select <b>Add Layer from Web</b>. The
                          Add Layer from Web dialog box is displayed.
                        </li>
                        <li>
                          Select either <b>A WMS OGC Web Service</b> or{" "}
                          <b>A WMTS OGC Web Service</b>.
                        </li>
                        <li>
                          <b>Copy-paste the following URL</b>:
                          <br />
                          <b className="copyTextForEsriPortalURLOnlineWMTS">
                            {this.state && this.state.siteName !== ""
                              ? this.state.SGBaseUrl + "/" +
                              this.state.siteName +
                              "/" +
                              this.state.accessToken +
                              "/arcgis/rest/services/wmsserver"
                              : this.state.SGBaseUrl + "/[CUSTOMER_KEY]/[TOKEN]/arcgis/rest/services/wmsserver"}
                          </b>
                          <button className="btn btn-outline-primary text-capitalize ml-1 copyToClipboard" onClick={(event) => {
                            var currentTarget = event.currentTarget;
                            SLCommon.copyToClipboard(document.getElementsByClassName("copyTextForEsriPortalURLOnlineWMTS")[0])
                              .then(() => { currentTarget.innerText = this.state.copiedText });
                          }}>{this.state.copyText}</button>
                          <br />
                          <b>Note: </b>All SGS layers must be on public HTTPS servers.
                        </li>
                        <li>
                          Click <b>Get Layers.</b>
                        </li>
                        <li>
                          Check all the layers you want to add and click{" "}
                          <b>Add Layer</b>.
                        </li>
                      </ul>
                    </div>
                  </ScrollableAnchor>
                </div> : null}
              </div>
              :
              ""
          }      
          <br />
          <br />
          <br />
        </div>
      </main>
    );
  }
}

export default FAQ;
